import gql from 'graphql-tag';

export const UpdateParticipantEmbeddableForm = gql`
  mutation UpdateParticipantEmbeddableForm(
    $organizationId: ID!
    $participantId: ID!
    $participantEmbeddableFormId: ID!
    $request: UpdateParticipantEmbeddableFormRequest!
  ) {
    updateParticipantEmbeddableForm(
      organizationId: $organizationId
      participantId: $participantId
      participantEmbeddableFormId: $participantEmbeddableFormId
      request: $request
    ) {
      id
    }
  }
`;
